<template>
    <div class="uk-form-controls js-upload upload-image" uk-form-custom>
        <label>
            <img :src="imagePath" />
            <input type="file" :name="fieldName" @change="onFileChange" />
            <button class="uk-button uk-button-default image-button-overlay" :class="{'always-on':forceButton}" type="button" tabindex="-1">
                <i class="fas fa-upload"></i>
                {{ fieldLabel }}
            </button>
        </label>
        <div v-if="changed" class="reminder uk-text-center">Click save to keep this image.</div>
    </div>
</template>

<script>
    export default {
        name: "ImageUploader",

        components: {},

        props:{
            imagePath:{type:String, default:null},
            fieldName:{type:String, default:null},
            fieldLabel:{type:String, default:null},
        },

        data() {
            return {
                filePath:"",
                changed:false
            };
        },

        mounted() {

        },

        methods: {
            onFileChange(e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                    return;
                this.createImage(files[0]);
            },
            createImage(file) {
                var reader = new FileReader();

                reader.onload = (e) => {
                    this.imagePath = e.target.result;
                    this.changed = true;
                };
                reader.readAsDataURL(file);
            }
        },

        computed:{
            forceButton(){
                console.log
                return this.imagePath == null || this.imagePath == "/images/blank_user.png";
            }
        }
    }
</script>
